import { render, staticRenderFns } from "./Video.page.vue?vue&type=template&id=12922824&scoped=true&"
import script from "./Video.page.vue?vue&type=script&lang=js&"
export * from "./Video.page.vue?vue&type=script&lang=js&"
import style0 from "./Video.page.vue?vue&type=style&index=0&id=12922824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12922824",
  null
  
)

export default component.exports